import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  TextField,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Formik } from "formik";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import Header from "../../components/Header";
import { createAudio, getAllArtists } from "./../../ApiConfig.jsx";

const AddNewAudio = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [artists, setArtists] = useState([]);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const getArtists = async () => {
      try {
        const artistData = await getAllArtists();
        if (artistData.status) {
          setArtists(artistData.result);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getArtists();
  }, []);

  const handleFormSubmit = async (values) => {
    console.log(values);

    const formData = new FormData();
    formData.append("title", values.audio_track_title);
    if (values.type == "Paid") {
      formData.append("amount", values.amount);
    } else {
      formData.append("amount", "0");
    }

    if (values.audio_type == "Artist") {
      formData.append("artist_name", values.artist);
    } else {
      formData.append("artist_name", "Bible");
    }
    setIsLoading(true);
    formData.append("type", values.type);
    formData.append("audio_type", values.audio_type);

    formData.append("language", values.language);
    formData.append("status", "Active");
    formData.append("audio", values.audio);
    formData.append("image", values.image);

    try {
      const response = await createAudio(formData);
      console.log(response.data);
      if (response.status) {
        setAlertSeverity("success");
        setAlertMessage("Audio added successfully");
        setTimeout(() => {
          navigate("/audio-management");
        }, 2500);
      }
    } catch (error) {
      setAlertSeverity("error");
      setAlertMessage(`Failed to add new audio : ${error.message}`);
    } finally {
      setOpenSnackbar(true);
      setIsLoading(false);
    }
  };

  return (
    <Box m="20px" height="70vh" overflow="auto" paddingRight="20px">
      <Header title="Add New Audio" subtitle="" />

      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit} style={{ height: "41vh" }}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns={
                isNonMobile ? "repeat(2, 1fr)" : "repeat(1, 1fr)"
              }
            >
              <Box>
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Audio Track Title*"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.audio_track_title}
                  name="audio_track_title"
                  error={
                    !!touched.audio_track_title && !!errors.audio_track_title
                  }
                  helperText={
                    touched.audio_track_title && errors.audio_track_title
                  }
                />
              </Box>
              <Box>
                <FormControl fullWidth variant="filled">
                  <InputLabel>Select Audio Type*</InputLabel>
                  <Select
                    variant="filled"
                    value={values.audio_type}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name="audio_type"
                    error={!!touched.audio_type && !!errors.audio_type}
                    helperText={touched.audio_type && errors.audio_type}
                  >
                    <MenuItem value="Bible">Bible</MenuItem>
                    <MenuItem value="Artist">Artist</MenuItem>
                    <MenuItem value="Podcast">Podcast</MenuItem>
                  </Select>
                  {touched.audio_type && errors.audio_type && (
                    <FormHelperText style={{ color: "#f44336" }}>
                      {errors.audio_type}
                    </FormHelperText>
                  )}
                </FormControl>
              </Box>

              {values.audio_type == "Artist" && (
                <Box>
                  <FormControl fullWidth variant="filled">
                    <InputLabel>Artist*</InputLabel>
                    <Select
                      variant="filled"
                      value={values.artist}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="artist"
                      error={!!touched.artist && !!errors.artist}
                      helperText={touched.artist && errors.artist}
                    >
                      {artists.map((artist, index) => {
                        return (
                          <MenuItem key={index} value={artist.artist_name}>
                            {artist.artist_name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    {touched.artist && errors.artist && (
                      <FormHelperText style={{ color: "#f44336" }}>
                        {errors.artist}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Box>
              )}
              <Box>
                <FormControl fullWidth variant="filled">
                  <InputLabel>Select Type*</InputLabel>
                  <Select
                    variant="filled"
                    value={values.type}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name="type"
                    error={!!touched.type && !!errors.type}
                    helperText={touched.type && errors.type}
                  >
                    <MenuItem value="Free">Free</MenuItem>
                    <MenuItem value="Paid">Paid</MenuItem>
                  </Select>
                  {touched.type && errors.type && (
                    <FormHelperText style={{ color: "#f44336" }}>
                      {errors.type}
                    </FormHelperText>
                  )}
                </FormControl>
              </Box>

              <Box>
                <FormControl fullWidth variant="filled">
                  <InputLabel>Language*</InputLabel>
                  <Select
                    variant="filled"
                    value={values.language}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name="language"
                    error={!!touched.language && !!errors.language}
                    helperText={touched.language && errors.language}
                  >
                    <MenuItem value="English">English</MenuItem>
                    <MenuItem value="French">French</MenuItem>
                  </Select>
                  {touched.language && errors.language && (
                    <FormHelperText style={{ color: "#f44336" }}>
                      {errors.language}
                    </FormHelperText>
                  )}
                </FormControl>
              </Box>

              {values.type == "Paid" && (
                <Box>
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Amount*"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.amount}
                    name="amount"
                    error={!!touched.amount && !!errors.amount}
                    helperText={touched.amount && errors.amount}
                  />
                </Box>
              )}

              <Box>
                {" "}
                <InputLabel htmlFor="eventType">Upload a Audio*</InputLabel>
                <TextField
                  fullWidth
                  variant="filled"
                  type="file"
                  accept="audio/*"
                  onBlur={handleBlur}
                  onChange={(event) =>
                    handleChange({
                      target: {
                        name: "audio",
                        value: event.currentTarget.files[0],
                      },
                    })
                  }
                  name="audio"
                  error={!!touched.audio && !!errors.audio}
                  helperText={touched.audio && errors.audio}
                />
              </Box>

              <Box>
                {" "}
                <InputLabel htmlFor="eventType">Upload a Image*</InputLabel>
                <TextField
                  fullWidth
                  variant="filled"
                  type="file"
                  onBlur={handleBlur}
                  accept="image/*"
                  onChange={(event) =>
                    handleChange({
                      target: {
                        name: "image",
                        value: event.currentTarget.files[0],
                      },
                    })
                  }
                  name="image"
                  error={!!touched.image && !!errors.image}
                  helperText={touched.image && errors.image}
                />
              </Box>
            </Box>{" "}
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                variant="contained"
                sx={{
                  backgroundColor: "#6870fa",
                  color: "white",
                  fontSize: "16px",
                  "&:hover": {
                    backgroundColor: "#3e4396",
                  },
                }}
              >
                {isLoading ? "Adding..." : "Add"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={5000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          onClose={() => setOpenSnackbar(false)}
          severity={alertSeverity}
          elevation={6}
          variant="filled"
          style={{ color: "white" }}
        >
          {alertSeverity === "success" ? "Success" : "Error"}
          {": "}
          {alertMessage}
        </MuiAlert>
      </Snackbar>
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  audio_track_title: yup.string().required("Audio track title is required"),
  artist: yup.string().required("Artist is required"),
  type: yup.string().required("Type is required"),
  audio_type: yup.string().required("Audio type is required"),
  language: yup.string().required("Language is required"),
  amount: yup.string().when("type", {
    is: (val) => val === "Paid",
    then: yup
      .string()
      .required("Amount is required")
      .matches(/^\d+$/, "Amount must contain only numbers"),
    otherwise: yup.string(),
  }),
  artist: yup.string().when("audio_type", {
    is: (val) => val === "artist",
    then: yup.string().required("Artist is required"),
    otherwise: yup.string(),
  }),
  audio: yup
    .mixed()
    .required("Audio is required")
    .test("fileType", "Please enter a valid audio type", (value) => {
      return !value || (value && value.type.startsWith("audio/"));
    }),
  image: yup
    .mixed()
    .required("Image is required")
    .test("fileType", "Please enter a valid image type", (value) => {
      return !value || (value && value.type.startsWith("image/"));
    }),
});

const initialValues = {
  audio_track_title: "",
  artist: "",
  type: "",
  audio_type: "",
  language: "",
  amount: "",
  audio: null,
  image: null,
};

export default AddNewAudio;
